// extracted by mini-css-extract-plugin
module.exports = {"browseInput":"discount-form_browseInput__1Nd7u","browseButton":"discount-form_browseButton__33Psp"};